import { Anchor, Badge, Button, Card, Flex, Grid, Tooltip } from '@mantine/core';
import { IconAward, IconChartLine, IconHistory, IconMail, IconPackages } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import prettifiedLabel from '../../constants/labelPrettifier';
import { templateStatusColor, viberTemplateSenders } from '../../constants/viberTemplateLanguages';
import ViberMessagesStats from './ViberMessagesStats';

const ViberMessagesCards = ({ viberMessages, stats, period }) => {
  const currentDomain = useSelector((state) => state.domain.domain);
  const domainCurrency = currentDomain.currency;
  const location = useLocation();
  const { accountId, domainId } = useParams();

  return viberMessages.map((viberMessage) => (
    <Card key={viberMessage.id} mb="md" withBorder>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <Anchor
              href={`#${location.pathname}/${viberMessage.id}/details`}
              fw={600}
              mb="xs"
              style={{ display: 'block' }}
            >
              {viberMessage.name}
            </Anchor>
            <Flex gap="xs" wrap="wrap">
              <Badge variant="default">
                {viberMessage.type === 'recommender' ? (
                  <IconAward size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
                ) : (
                  <IconMail size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
                )}
                {prettifiedLabel(viberMessage.type)}
              </Badge>
              {viberMessage.isPromotional === false &&
                viberTemplateSenders.includes(currentDomain?.viberMessageSender) && (
                  <Tooltip label="Viber transactional template status" position="top" withArrow>
                    <Badge color={templateStatusColor(viberMessage.templateStatus)} style={{ cursor: 'default' }}>
                      {viberMessage.templateStatus || 'Not submitted'}
                    </Badge>
                  </Tooltip>
                )}
              {viberMessage.type === 'recommender' && viberMessage.productFeed && (
                <Badge variant="default">
                  <IconPackages size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
                  <Anchor
                    href={`#/accounts/${accountId}/domains/${domainId}/productFeeds/${viberMessage.productFeed.id}/details`}
                    target="_blank"
                    size="xs"
                  >
                    {viberMessage.productFeed.name}
                  </Anchor>
                </Badge>
              )}
              <Tooltip
                label={
                  <>
                    <div>Created: {new Date(viberMessage.createdAt).toLocaleString()}</div>
                    <div>Updated: {new Date(viberMessage.updatedAt).toLocaleString()}</div>
                  </>
                }
                position="top"
                withArrow
              >
                <Badge variant="default" style={{ cursor: 'pointer' }}>
                  <IconHistory size={14} style={{ verticalAlign: 'middle' }} />
                </Badge>
              </Tooltip>
            </Flex>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Flex justify="flex-end" align="flex-start">
              <Button component="a" href={`#${location.pathname}/${viberMessage.id}/analytics`} size="xs">
                Statistics <IconChartLine size={14} style={{ marginLeft: 4 }} />
              </Button>
            </Flex>
          </Grid.Col>
        </Grid>
      </Card.Section>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <ViberMessagesStats stats={stats} viberMessage={viberMessage} period={period} currency={domainCurrency} />
        </Grid>
      </Card.Section>
    </Card>
  ));
};

export default ViberMessagesCards;
